"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _Link = _interopRequireDefault(require("../Link"));
var _index = _interopRequireDefault(require("./index.style"));
const PageSection = _ref => {
  let {
    title,
    description,
    textFragment,
    textFragment1,
    textFragment2,
    linkText,
    linkHref,
    linkTarget,
    children,
    className
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(classes.rootPageSection, className)
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "h1"
  }, title), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    paragraph: true
  }, description, /*#__PURE__*/_react.default.createElement("span", null, textFragment), /*#__PURE__*/_react.default.createElement("span", null, textFragment1), /*#__PURE__*/_react.default.createElement("span", null, textFragment2), linkText !== '' && /*#__PURE__*/_react.default.createElement(_Link.default, {
    href: linkHref,
    target: linkTarget
  }, linkText)), children);
};
var _default = exports.default = PageSection;